import { useGame } from './useGame';
import { Bar } from './ui/Bar';
import { Elevator } from './ui/Elevator';
import { Hub } from './ui/Hub';
import { Bust, NotBuilt, Title } from './ui/Screens';
import { Owner, Shop } from './ui/Shop';
import { Table } from './ui/Table';

export function App() {
  const [snapshot, actions] = useGame();
  switch (snapshot.screen) {
    case 'title':
    case 'resetConfirm':
    case 'newRunConfirm':
      return <Title snapshot={snapshot} actions={actions} />;
    case 'hub':
      return <Hub snapshot={snapshot} actions={actions} />;
    case 'table':
      return <Table snapshot={snapshot} actions={actions} />;
    case 'bar':
      return <Bar snapshot={snapshot} actions={actions} />;
    case 'shop':
      return <Shop snapshot={snapshot} actions={actions} />;
    case 'elevator':
      return <Elevator snapshot={snapshot} actions={actions} />;
    case 'owner':
      return <Owner snapshot={snapshot} actions={actions} />;
    case 'bust':
      return <Bust snapshot={snapshot} actions={actions} />;
    default:
      return <NotBuilt actions={actions} />;
  }
}
